class Panel extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.locked = false;
    this.selectors = {
      autofocus: '.show-sidebar-cart',
    };
  }

  onShow() {}

  connectedCallback() {
    this.addEventListener('custom:escape', (ev) => {
      this.hide();
    });

    this.addEventListener('transitionstart', (ev) => (this.locked = true));
    this.addEventListener('transitionend', (ev) => (this.locked = false));
  }

  show() {
    if (this.locked) return;
    this.classList.remove('hidden');
    this.backdrop?.classList.remove('hidden');
    const currentScrollPosition = document.documentElement.scrollTop;
    if (currentScrollPosition > 0) {
      document.querySelector('shallow-clone')?.pauseScroll();
      window.cacheHeight(currentScrollPosition);
    }
    requestAnimationFrame(() => {
      this.classList.remove('translate-x-full');
      if (document.documentElement.getBoundingClientRect().height > window.innerHeight) {
        document.documentElement.classList.add('overscroll-auto', 'fixed', 'w-full');
      }
    });
    waitForTransitionEnd(this).then(() => {
      trapFocus(this);
      this.isOpen = true;
      this.onShow();
    });
  }

  hide() {
    if (this.locked) return;
    this.classList.add('translate-x-full');
    this.backdrop?.classList.add('hidden');
    releaseFocus(this);
    this.isOpen = false;
    document.querySelector(this.selectors.autofocus)?.focus();
    document.documentElement.classList.remove('overscroll-auto', 'fixed', 'w-full');
    requestAnimationFrame(() => {
      window.restoreHeight();
    });
    waitForTransitionEnd(this).then(() => this.classList.add('hidden'));
  }
}

class SidePanel extends Panel {
  constructor() {
    super();
    this.backdrop = this.parentNode.querySelector('.side-panel-backdrop');

    this.fetchCartDrawer();
  }

  bindEvents() {
    document.querySelector('.show-sidebar-cart')?.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.show();
    });

    this.querySelector('button').addEventListener('click', (ev) => {
      this.hide();
    });

    this.addEventListener('click', (ev) => {
      if (ev.target.hasAttribute('close-side-panel')) {
        ev.preventDefault();
        this.hide();
      }
    });

    this.backdrop.addEventListener('click', (ev) => {
      this.hide();
    });

    if (this.id === 'side-panel-cart') {
      this.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  fetchCartDrawer() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        let placeholder = this.querySelector('#cart-drawer');

        if (placeholder) {
          placeholder.innerHTML = html.querySelector('#shopify-section-cart-drawer').innerHTML;
          this.bindEvents();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('side-panel', SidePanel);

class SearchPanel extends Panel {
  constructor() {
    super();
    this.bindEvents();
    this.selectors = {
      autofocus: '.open-search-panel',
    };
  }

  onShow() {
    requestAnimationFrame(() => {
      this.querySelector('[name="q"]')?.focus();
    });
  }

  bindEvents() {
    document.querySelector('.open-search-panel')?.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.show();
    });

    this.querySelectorAll('[close-panel]').forEach((element) => {
      element.addEventListener('click', (ev) => {
        this.hide();
      });
    });
  }
}

customElements.define('search-panel', SearchPanel);

class CurrencyPanel extends Panel {
  constructor() {
    super();
    this.bindEvents();
    this.selectors = {
      autofocus: '.open-currency-panel',
    };
  }

  onShow() {
    requestAnimationFrame(() => {
      this.querySelector('[name="q"]')?.focus();
    });
  }

  bindEvents() {
    document.querySelector('.open-currency-panel')?.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.show();
    });

    this.querySelectorAll('[close-panel]').forEach((element) => {
      element.addEventListener('click', (ev) => {
        this.hide();
      });
    });

    this.querySelector('[country-choice]')?.addEventListener('click', (ev) => {
      if (ev.target.nodeName === 'BUTTON' && ev.target.dataset.value) {
        ev.preventDefault();
        this.triggerForm(ev.target.dataset.value, 'country_code');
      }
    });

    this.querySelector('[top-country-choice]')?.addEventListener('click', (ev) => {
      if (ev.target.nodeName === 'BUTTON' && ev.target.dataset.value) {
        ev.preventDefault();
        this.triggerForm(ev.target.dataset.value, 'country_code');
      }
    });

    const countrySearchInput = this.querySelector('#country-search');
    if (countrySearchInput) {
      countrySearchInput.addEventListener('input', this.filterCountries.bind(this));
    }
  }

  filterCountries(event) {
    const normalize = (str) =>
      str
        .toLowerCase()
        .replace(/[^\p{L}\s]/gu, '')
        .replace(/\s+/g, ' ')
        .trim();
    const searchQuery = normalize(event.target.value);

    const countryItems = this.querySelectorAll('ul[country-choice] li');
    const noResultsMessage = this.querySelector('.country-choice-no-results');
    const topCountryChoice = this.querySelector('[top-country-choice]');

    let hasResults = false;

    if (topCountryChoice) {
      if (searchQuery.length > 0) {
        topCountryChoice.classList.add('hidden');
      } else {
        topCountryChoice.classList.remove('hidden');
      }
    }

    countryItems.forEach((item) => {
      const countryButton = item.querySelector('button');
      if (countryButton) {
        const countryName = normalize(countryButton.textContent);
        if (countryName.includes(searchQuery)) {
          item.classList.remove('hidden');
          hasResults = true;
        } else {
          item.classList.add('hidden');
        }
      }
    });

    if (noResultsMessage) {
      if (hasResults) {
        noResultsMessage.classList.add('hidden');
      } else {
        noResultsMessage.classList.remove('hidden');
      }
    }
  }

  triggerForm(value, name) {
    const controlInput = this.querySelector(`input[name="${name}"]`);
    controlInput.value = value;
    this.querySelector('form').submit();
  }
}

customElements.define('currency-panel', CurrencyPanel);
